import { Box, Flex, Grid, GridItem, Image, Input, Select, Text, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, FormControl, FormLabel, Button, Center, Spinner, Checkbox, } from '@chakra-ui/react'
import MyDiv from './educationDegree.style';
import { CustomButton, CustomToast } from '../../../../components';
import { useEffect, useState } from 'react';
import PlusIcon from "../../../../assets/images/Vector.svg";
import { IEducationDegree, IOptions } from './model';
import { useFetch } from '../../../../hooks/useFetch';
import CustomTables, { Column, ILazyParams } from '../../../../components/CustomTable/CustomTables';
import { EditIcon } from '@chakra-ui/icons';
import { IconButton } from '@chakra-ui/react';
const EducationDegree = () => {
    const [educationDegree, setEducationDegree] = useState<IEducationDegree[]>([]);
    const [DrawerOpen, setDrawerOpen] = useState(false);
    const [selectedId, setSelectedId] = useState<number | null>(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [options, setOptions] = useState<IOptions[]>([]);
    const [currentEducationDegree, setCurrentEducationDegree] = useState({ id: 0, degreeName: '', educationCategoryName: '', educationCategory_Id: 0, isCourseStream: false, });
    const { addToast } = CustomToast();
    const { fetchApi, loading } = useFetch(addToast);

    const [dataLoading, setDataLoading] = useState(false);
    const [totalCount, setTotalCount] = useState(0);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0, rows: 20, sortField: undefined, sortOrder: undefined,
        multiSortMeta: [], filters: {}, globalFilter: '',
    });

    useEffect(() => {
        loadCategoryData();
    }, []);

    useEffect(() => {
        loadEducationDegrees();
    }, [lazyParams]);

    const loadEducationDegrees = async () => {
        setDataLoading(true);
        const params = new URLSearchParams();
        params.set('first', String(lazyParams.first));
        params.set('rows', String(lazyParams.rows));
        if (lazyParams.sortField) params.set('sortField', lazyParams.sortField);
        if (lazyParams.sortOrder) params.set('sortOrder', String(lazyParams.sortOrder));
        if (lazyParams.globalFilter) params.set('globalFilter', lazyParams.globalFilter);
        if (lazyParams.filters && Object.keys(lazyParams.filters).length) {
            params.set('filters', JSON.stringify(lazyParams.filters));
        }

        const response = await fetchApi<any>(`Hrlense_EducationDegrees?${params.toString()}`, "GET");
        if (response) {
            setEducationDegree(response.data ?? []);
            setTotalCount(response.totalRecords ?? 0);
        }
        setDataLoading(false);
    };

    const loadCategoryData = async () => {
        const response = await fetchApi<IOptions[]>("Hrlense_EducationCategories", "GET");
        if (response) setOptions(response);
    };

    const handleAddNewDegree = () => {
        setIsEditMode(false);
        setCurrentEducationDegree({ id: 0, degreeName: '', educationCategoryName: '', educationCategory_Id: 0, isCourseStream: false, });
        setDrawerOpen(true);
    };

    const handleEditEducation = (educationDegree: IEducationDegree) => {
        setIsEditMode(true);
        setSelectedId(educationDegree.id);
        setCurrentEducationDegree({
            id: educationDegree.id,
            degreeName: educationDegree.degreeName,
            educationCategoryName: educationDegree.educationCategoryName,
            educationCategory_Id: educationDegree.educationCategory_Id ?? 0,
            isCourseStream: educationDegree.isCourseStream,
        });
        setDrawerOpen(true);
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value, type } = e.target;
        setCurrentEducationDegree((prev) => ({
            ...prev,
            [name]:
                type === "checkbox" ? (e.target as HTMLInputElement).checked : name === "educationCategory_Id" ? parseInt(value) : value,
        }));
    };


    const handleSubmit = async () => {
        let success = false;
        if (isEditMode) {
            const response = await fetchApi(`Hrlense_EducationDegrees/${currentEducationDegree.id}`, "PUT", { id: currentEducationDegree.id, degreeName: currentEducationDegree.degreeName, educationCategory_Id: currentEducationDegree.educationCategory_Id, isCourseStream: currentEducationDegree.isCourseStream, }, null, "Education Degree updated successfully");
            if (response) {
                success = true;
            }
        } else {
            const response = await fetchApi<IEducationDegree>("Hrlense_EducationDegrees", "POST", { id: currentEducationDegree.id, degreeName: currentEducationDegree.degreeName, educationCategory_Id: currentEducationDegree.educationCategory_Id, isCourseStream: currentEducationDegree.isCourseStream, }, null, "Education Degree added successfully"
            );
            if (response) {
                success = true;
            }
        }
        if (success) {
            setDrawerOpen(false);
            await loadEducationDegrees();
        }
    };

    return (
        <MyDiv>
            <Box position="relative" minH="300px">
                <>
                    <Flex className="page_heading flex_header" >
                        <Text className="font-poppins text_semibold text_3xl">Education-Degree </Text>
                        <Flex gap={2}>
                            <CustomButton title="Add New Degree" className=' btn font-poppins text_sm text_medium' rightIcon={<Image src={PlusIcon} className='logo' />} onClick={handleAddNewDegree} />
                        </Flex>
                    </Flex>
                    <Grid className='grid_container'>
                        <GridItem colSpan={12}>
                            <CustomTables<IEducationDegree>
                                value={educationDegree} loading={dataLoading} emptyMessage="No Education Degrees Found"
                                preferenceKey="educationDegreeTable"  showGlobalSearch={false}   showToolbar={true}
                                lazy lazyParams={lazyParams} onLazyParamsChange={setLazyParams} totalRecords={totalCount}
                                showPagination rowsPerPageOptions={[20, 100, 200, 500]} maxTableHeight={null}
                            >
                                <Column header="S. No" body={(_, index) => lazyParams.first + index + 1} /> {/* Adjust S.No for pagination */}
                                <Column header="Degree Name" field="degreeName" sortable filterable filterType="text" />
                                <Column header="Education Category" field="educationCategoryName" sortable filterable filterType="text" />
                                <Column header="Course Stream Required" field="isCourseStream" body={(row: IEducationDegree) => row.isCourseStream ? "Yes" : "No"} sortable filterable filterType="boolean" />
                                <Column header="Actions" frozen="right" body={(row: IEducationDegree) => (
                                        <IconButton  aria-label="Edit" icon={<EditIcon />} size="sm" colorScheme="orange" variant="ghost" onClick={() => handleEditEducation(row)}
                                        />
                                    )}
                                />
                            </CustomTables>

                        </GridItem>
                    </Grid>

                    <Drawer isOpen={DrawerOpen} placement="right" onClose={() => setDrawerOpen(false)} size="sm">
                        <DrawerOverlay />
                        <DrawerContent>
                            <DrawerCloseButton />
                            <DrawerHeader borderBottomWidth="1px">{isEditMode ? 'Edit Degree' : 'Add New Degree'}</DrawerHeader>
                            <DrawerBody display="flex" flexDirection="column" justifyContent="space-between" height="100%">
                                <Box py={4}>
                                    <FormControl mb={4} isRequired>
                                        <FormLabel>Education Category</FormLabel>
                                        <Select name="educationCategory_Id" value={currentEducationDegree.educationCategory_Id} onChange={handleInputChange} placeholder="Select Education Category">
                                            {options.map((option) => (  <option key={option.id} value={option.id}> {option.educationName} </option>  ))}
                                        </Select>
                                    </FormControl>

                                    <FormControl mb={4} isRequired>
                                        <FormLabel>Degree Name</FormLabel>
                                        <Input name="degreeName" value={currentEducationDegree.degreeName} onChange={handleInputChange} placeholder="Enter Education name" />
                                    </FormControl>
                                    <FormControl mb={4} isRequired>
                                        <Checkbox name="isCourseStream" isChecked={currentEducationDegree.isCourseStream} onChange={handleInputChange}
                                        >
                                            Is Course Stream Required
                                        </Checkbox>
                                    </FormControl>

                                </Box>
                                <Flex justify="flex-end" mt={4} gap={2}>
                                    <Button className="font-poppins text_sm text_medium" onClick={() => setDrawerOpen(false)} style={{ backgroundColor: '#D92F34', color: 'white' }}>Cancel</Button>
                                    <Button onClick={handleSubmit} className="font-poppins text_sm text_medium" style={{ backgroundColor: '#006838', color: 'white' }}>{isEditMode ? "Update Degree" : "Add Degree"}</Button>
                                </Flex>
                            </DrawerBody>
                        </DrawerContent>
                    </Drawer>
                </>
            </Box>
        </MyDiv>
    )
}

export default EducationDegree;